/**
 * @fileoverview NotFoundPage (404) icon. JSON file in
 * `public/icons/NotFoundPage/`.
 */
export const NOT_FOUND_ICONS = {
  notFound: '/icons/NotFoundPage/usownftb.json',
} as const;
